import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BoxFull, Button, TransactionalSubheader } from "iuvity-ui-components";
import { Header } from "../../components";
import {
  CustomDialog,
  DialogProps,
} from "../../components/dialog/CustomDialog";
import { useMappedFields } from "../../hooks/useMappedFields";
import { AppContext } from "../../context/index";
import { PrivilegeValidatorComponent } from "../../components/shared/PrivilegeValidatorComponent";

export const DetailMappedFieldPage = () => {
  const navigate = useNavigate();
  const {
    t,
    appState: { user, selectedMappedField, permissiondInfoByRole },
    setAppState,
  } = useContext(AppContext);

  const { mappedFieldAction } = useMappedFields("ACTIONS");
  const [modalProps, setModalProps] = useState<DialogProps>({
    visible: false,
  } as DialogProps);

  const onReturn = () => {
    setAppState((prev) => ({
      ...prev,
      selectedMappedField: null,
    }));
    navigate(-1);
    window.scrollTo(0, 0);
  };

  const onDelete = async () => {
    const actionStatus = await mappedFieldAction(
      "DELETE",
      selectedMappedField?.id
    );
    if (actionStatus === "SUCCESS") navigate("/mappedFields");
  };

  const onEdit = () => {
    navigate("/mappedFields/edit");
  };

  const handleModalProps = () => {
    setModalProps((prev) => ({
      ...prev,
      visible: true,
      title: t("MappedFields.deleteModalTitle"),
      content: `${t("MappedFields.deleteModalContent1")} "${
        selectedMappedField?.name
      }" ${t("MappedFields.deleteModalContent2")}`,
      onConfirm: () => onDelete(),
    }));
  };

  return (
    <>
      {/* <Header
        welcomeMessage={t("Dashboard.welcomeTitle")}
        userName={user?.name}
      /> */}

      <TransactionalSubheader
        subheaderTitle={
          <div style={{ position: "relative", left: "-40px" }}>
            <i
              className="iu iu-icon-left pr-3"
              onClick={onReturn}
              aria-hidden="true"
              style={{
                fontSize: "var(--font-size-tablet-title)",
                cursor: "pointer",
              }}
            />
            {t("MappedFields.detailTitle")}
          </div>
        }
      >
        <TransactionalSubheader.BreadCrumb
          id={t("MappedFields.breadcrumbParentLabel")}
          disabledDefaultHome={true}
          breadcrumbsHomeItem={{
            icon: "iu iu-icon-home",
            command: () => navigate("/"),
          }}
          breadcrumbsItems={[
            {
              label: t("MappedFields.mappedFieldsTitle"),
              command: () => onReturn(),
              style: { fontFamily: "var(--fontBarlowSemiBold)" },
            },
            {
              label: t("GlobalConfigurations.detailTitle"),
              disabled: true
            },
          ]}
        />
        <TransactionalSubheader.Title />
      </TransactionalSubheader>

      <BoxFull
        className="mt-5 mb-3 p-0"
        style={{ backgroundColor: "transparent" }}
      >
        <BoxFull variant="secondary">
          <BoxFull className="my-5 py-2">
            <div className="flex-column align-items-center justify-content-center">
              <div className="dt-appr-c">
                <div className="dt-ap-col">
                  <div className="dt-ap-item">
                    <div className="item-title">
                      {t("MappedFields.nameLabel")}
                    </div>
                    <div className="item-value">
                      {selectedMappedField?.name}
                    </div>
                  </div>

                  <div className="dt-ap-item">
                    <div className="item-title">
                      {t("MappedFields.labelkeyLabel")}
                    </div>
                    <div className="item-value">
                      {selectedMappedField?.labelkey}
                    </div>
                  </div>

                  <div className="dt-ap-item">
                    <div className="item-title">
                      {t("MappedFields.jsonpathLabel")}
                    </div>
                    <div className="item-value">
                      {selectedMappedField?.jsonpath}
                    </div>
                  </div>

                  <div className="dt-ap-item">
                    <div className="item-title">
                      {t("MappedFields.serviceapiLabel")}
                    </div>
                    <div className="item-value">
                      {selectedMappedField?.serviceapi}
                    </div>
                  </div>

                  <div className="dt-ap-item">
                    <div className="item-title">
                      {t("MappedFields.dashboardoptionLabel")}
                    </div>
                    <div className="item-value">
                      {selectedMappedField?.dashboardoption}
                    </div>
                  </div>
                </div>

                <div className="dt-ap-col">
                  <div className="dt-ap-item">
                    <div className="item-title">
                      {t("MappedFields.descriptionLabel")}
                    </div>
                    <div className="item-value">
                      {selectedMappedField?.description}
                    </div>
                  </div>

                  <div className="dt-ap-item">
                    <div className="item-title">
                      {t("MappedFields.descriptionlabelkeyLabel")}
                    </div>
                    <div className="item-value">
                      {selectedMappedField?.descriptionlabelkey}
                    </div>
                  </div>

                  <div className="dt-ap-item">
                    <div className="item-title">
                      {t("MappedFields.extrajsonpathLabel")}
                    </div>
                    <div className="item-value">
                      {selectedMappedField?.extrajsonpath === ""
                        ? "NO APLICA"
                        : selectedMappedField?.extrajsonpath}
                    </div>
                  </div>

                  <div className="dt-ap-item">
                    <div className="item-title">
                      {t("MappedFields.datatypeLabel")}
                    </div>
                    <div className="item-value">
                      {selectedMappedField?.datatype}
                    </div>
                  </div>

                  <div className="dt-ap-item">
                    <div className="item-title">
                      {t("MappedFields.releaseversionLabel")}
                    </div>
                    <div className="item-value">
                      {selectedMappedField?.releaseversion}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </BoxFull>
        </BoxFull>
      </BoxFull>

      <BoxFull className="my-5">
        <div className="flex align-items-start justify-content-center">
          <div className="inputlabel subtitle p-1">{`${t(
            "MappedFields.creationDateLabel"
          )}:`}</div>
          <div className="inputlabel label px-1">{`${selectedMappedField?.createdat}`}</div>
        </div>
        <div className="flex align-items-start justify-content-center">
          <div className="inputlabel subtitle p-1">{`${t(
            "MappedFields.creatorLabel"
          )}:`}</div>
          <div className="inputlabel label px-1">
            {selectedMappedField?.createdby || "System"}
          </div>
        </div>
      </BoxFull>

      <BoxFull className="my-5 p-0" style={{ backgroundColor: "transparent" }}>
        <div className="flex align-items-center justify-content-end gap-5">
          <Button
            variant="p-button-link"
            label={t("MappedFields.returnBtnLabel")}
            onClick={onReturn}
          />
          {selectedMappedField?.createdby && (
            <PrivilegeValidatorComponent showButton={permissiondInfoByRole.REMOVE} >
              <Button
                variant="p-button-link"
                label={t("TableActions.deleteLabel")}
                onClick={handleModalProps}
              />
            </PrivilegeValidatorComponent>
          )}
          <PrivilegeValidatorComponent showButton={permissiondInfoByRole.UPDATE} >
            <Button
              variant="p-button"
              label={t("TableActions.editLabel")}
              onClick={onEdit}
            />
          </PrivilegeValidatorComponent>
        </div>
      </BoxFull>

      <CustomDialog
        title={modalProps.title}
        visible={modalProps.visible}
        content={modalProps.content}
        handleModalState={setModalProps}
        onConfirm={modalProps.onConfirm}
      />
    </>
  );
};
